const state = {
    //bodyBgColor: "#FFF"
    navBarLink: {
        navList: [],
        outsiteLink: []
    }
}

export default state;